import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["inci"]

  updateInciValue(event) {
    const value = event.detail.selected.dataset.inci
    if (!value) return

    this.inciTarget.value = value
  }

  handlePaste(event) {
    const pastedText = event.clipboardData.getData("text")
    if (!pastedText.includes("\n")) return

    event.preventDefault()
    const ingredients = pastedText
      .split("\n")
      .map((s) => s.trim())
      .filter((s) => s.length > 0)
    this.inciTarget.value = ingredients.join(" (and) ")
    this.inciTarget.dispatchEvent(new Event("input", { bubbles: true }))
  }
}
